import React, { Component } from "react"
import PropTypes from "prop-types"
import {
  StaticLayout,
  LayoutState,
  Row1,
  Row2,
  Row3,
  Row4,
  Row5,
  Row6,
  Row7,
  Body,
  Content,
  ContentCarousel,
  CarouselView,
  FlatButtonView,
  FAButtonView,
  IconButtonView,
  TextView,
  ImageView,
  ImageTextView,
  AvatarView,
  DividerView,
  ProductListView,
  EmptyView,
  YoutubeView,
  CarouselAnimationView,
  DealGroupView,
} from "./layout"

const comps = {
  Row1,
  Row2,
  Row3,
  Row4,
  Row5,
  Row6,
  Row7,
  Body,
  Content,
  ContentCarousel,
  TextView,
  ImageView,
  ImageTextView,
  AvatarView,
  DividerView,
  CarouselView,
  CarouselAnimationView,
  FlatButtonView,
  IconButtonView,
  FAButtonView,
  ProductListView,
  EmptyView,
  YoutubeView,
  DealGroupView,
}

class StaticPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      layoutState: props.data
        ? LayoutState.fromRaw(props.data)
        : new LayoutState(),
    }
  }

  render() {
    return (
      <div style={{ position: "relative", height: "100%", width: "100%" }}>
        <StaticLayout layoutState={this.state.layoutState} components={comps} />
      </div>
    )
  }
}

StaticPage.propTypes = {
  data: PropTypes.object,
}

export default StaticPage



// WEBPACK FOOTER //
// ./src/contents/editorPreview/index.js